import { useTranslation } from 'react-i18next';
import { stats } from '@/mocks/stats';

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              {t('home:sectionStats')}
            </h2>
            <p className="text-sm text-foreground-500 max-w-md mx-auto">
              {t('home:sectionStatsDesc')}
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/70"
              >
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-accent-100">
                  <i className={`${stat.icon} text-xl text-accent-600`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">
                  {stat.value}
                  <span className="text-lg text-primary-500">{stat.suffix}</span>
                </div>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-3">
                  番号本持续更新中
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed max-w-lg">
                  我们每天都在收录和更新番号信息，确保您获取到最新、最全的番号数据。无论是查询特定番号还是浏览分类内容，番号本都是您最可靠的选择。
                </p>
              </div>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <div className="flex items-center gap-3 bg-background-50 rounded-xl px-5 py-3 border border-background-200/70">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">数据更新中</span>
                </div>
                <div className="flex items-center gap-3 bg-background-50 rounded-xl px-5 py-3 border border-background-200/70">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shield-check-line text-sm text-accent-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">数据精准可靠</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}